import { addDays, endOfDay } from 'date-fns'
import { useUserStore } from '@/stores/user'

export function useEntityDates() {
  const userStore = useUserStore()

  /**
   * Get current date like we are in entity timezone
   * @param entityId Optional entity id; falls back to the currently active entity
   * @return Date Current date
   */
  function getEntityCurrentDate(entityId?: string) {
    if (entityId) {
      return userStore.dateWithTzOffset(new Date(), entityId)
    }
    return userStore.getEntityDate(new Date())
  }

  /**
   * Get last close date like we are in entity timezone
   * @param entityId Optional entity id; falls back to the currently active entity
   * @return Date Last close date
   */
  function getEntityLastCloseDate(entityId?: string) {
    return endOfDay(addDays(getEntityCurrentDate(entityId), -1))
  }

  /**
   * Get entity month start date like in close time of entity timezone
   * @returns Date Month start date
   */
  function getEntityMonthStartDateClose() {
    const date = new Date()
    return userStore.getEntityDate(
      new Date(date.getFullYear(), date.getMonth(), 1)
    )
  }

  /**
   * Get date from string like we are in entity timezone of current entity
   * @param entryDateString
   * @return Date Date in current timezone
   */
  function stringToTzDate(entryDateString: string) {
    return userStore.stringToEntityTzDate(entryDateString)
  }

  return {
    getEntityCurrentDate,
    getEntityLastCloseDate,
    getEntityMonthStartDateClose,
    stringToTzDate,
  }
}
